import Log from "@/pages/log/Listar";

export const logRoutes = [
  {
    path: "/logs",
    name: "logs",
    component: Log,
  }
];

export default {};
